import Link from 'next/link';
import styled from 'styled-components';

export const Wrapper = styled.div<{ topMargin?: number }>`
  height: auto;
  max-height: 694px;
  width: 1100px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white};
  border-top: 2px solid ${({ theme }) => theme.palette.tomato};
  z-index: 100;
  overflow: hidden;
`;

export const ItemsWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding: 12px 30px 10px 25px;
  gap: 30px;
  overflow: hidden;
`;
export const Item = styled.div`
  & > a {
    text-decoration: none !important;
  }
`;

export const LinksItems = styled.div`
  overflow-y: auto !important;
  height: 100%;
  max-height: 280px;

  ::-webkit-scrollbar {
    width: 0;
    background-color: ${({ theme }) => theme.palette.white};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${({ theme }) => theme.palette.white};
  }
  & > a {
    text-decoration: none !important;
  }
`;
export const ItemTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.coral};
  margin-bottom: 8px;
  display: block;
  height: 23px;
`;
export const ItemLinkContainer = styled.div<{
  backgroundColor?: string;
  color?: string;
}>`
  display: flex;
  padding: 4px;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  width: 100%;
  height: 26px;
  background-color: ${(props) => props.backgroundColor || 'transparent'};
  margin-bottom: 8px;
  border-radius: 8px;
`;
export const ItemLinkDyanmic = styled(Link)<{
  color?: string;
}>`
  font-size: 14px;
  color: ${(props) => props.color || '#292a2c'} !important;
  margin-bottom: 8px;
  display: block;
  text-decoration: none;
  font-weight: 600;
  line-height: normal;
`;
export const ItemLink = styled(Link)`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.darkGrey} !important;
  margin-bottom: 8px;
  display: block;
  text-decoration: none;
  :hover {
    color: ${({ theme }) => theme.palette.tomato} !important;
  }
`;
export const ItemSubItemBox = styled(Link)`
  display: flex;
  text-decoration: none;
`;
export const ItemSubItemLink = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.eclipse};
  margin-right: 5px;
`;

export const PhotosWrapper = styled.div`
  height: auto;
  bottom: 0;
  padding: 12px 20px 12px 20px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  border-top: 1px solid ${({ theme }) => theme.palette.lightBlueGrey};

  display: grid;
  grid-template-columns: repeat(4, 250px);
  gap: 8px 20px;
  justify-items: center;
`;

export const PhotosItem = styled.div`
  position: relative;
  height: 100px;
  width: 100%;
  border-radius: 8px;
`;

export const PhotosItemImage = styled.div<{ image?: string }>`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background-image: linear-gradient(
      to bottom,
      rgba(108, 108, 108, 0),
      ${({ theme }) => theme.palette.transparent2}
    ),
    ${({ image }) => `url(${image})`};

  background-size: cover;
`;
export const PhotosItemContent = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 9999;
  width: 92%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;
export const PhotosItemLabel = styled.span`
  display: block;
  font-size: 14px;
  font-weight: 900;
  color: ${({ theme }) => theme.palette.white};
  margin-bottom: 5px;
  text-shadow: 1px 1px 2px ${({ theme }) => theme.palette.D500};
`;
export const PhotosItemBorder = styled.span`
  height: 4px;
  width: 23px;
  border-radius: 3.1px;
  background-color: ${({ theme }) => theme.palette.coral};
  display: block;
`;
export const ChevronContainer = styled.div`
  margin-bottom: 12px;
`;
